'use client'

import {
  useCollectionFlashSale,
  useFlashSale,
} from '@/hooks/react-query/flash-sale/use-flash-sale'
import { TFlashSaleConfig } from '@/types/collection'
import { FlashSale as TFlashSale } from '@/types/flash-sale'
import { useEffect, useState } from 'react'
import { BannerCountDown } from './banner-count-down'
import { ProductFlashSale } from './product-flash-sale'

type FlashSaleData = {
  current: TFlashSale[] | null
  next: TFlashSale[] | null
  countDownTime: Date | null
}

type FlashSaleViewProps = {
  flashSales?: FlashSaleData
  config?: TFlashSaleConfig
}

const FlashSaleView = ({ flashSales, config }: FlashSaleViewProps) => {
  const [activeTab, setActiveTab] = useState<string>('current-0')
  const [type, indexStr] = activeTab.split('-')
  const index = parseInt(indexStr) || 0
  const selectedProgram = flashSales?.[type as 'current' | 'next']?.[index]
  const products = selectedProgram?.products || []

  useEffect(() => {
    if (flashSales) {
      if (flashSales.current?.length) {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- setting default active tab once query data loads
        setActiveTab('current-0')
      } else if (flashSales.next?.length) {
        setActiveTab('next-0')
      }
    }
  }, [flashSales])

  if (!flashSales || (!flashSales.current?.length && !flashSales.next?.length))
    return null

  return (
    <div className='mb-10'>
      <BannerCountDown
        countDownTime={flashSales.countDownTime}
        current={flashSales.current || []}
        next={flashSales.next || []}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        config={config}
      />
      <ProductFlashSale products={products} type={type as 'current' | 'next'} />
    </div>
  )
}

export const FlashSale = () => {
  const { data: flashSales } = useFlashSale()
  return <FlashSaleView flashSales={flashSales} />
}

// Flash sale cấu hình theo collection từ admin (collection_config.flash_sale)
export const CollectionFlashSale = ({
  config,
}: {
  config: TFlashSaleConfig
}) => {
  const { data: flashSales } = useCollectionFlashSale(config.program_ids || [])
  return <FlashSaleView flashSales={flashSales} config={config} />
}
